export const QUINCE_BOT_LOCATORS = {
  CUSTOM_SECTION: {
    COLLECTION_GRID_FIRST_ITEM: 'CUSTOM_SECTION__COLLECTION_GRID_FIRST_ITEM',
  },
  COLLECTION: {
    MOVE_TO_PDP: 'COLLECTION__MOVE_TO_PDP',
  },
  PDP: {
    FIRST_PRODUCT_OPTIONS: 'PDP__FIRST_PRODUCT_OPTIONS',
    ADD_TO_CART: 'PDP__ADD_TO_CART',
    BUY_NOW: 'PDP__BUY_NOW',
  },
  CART: {
    CHECKOUT_BUTTON: 'CART__CHECKOUT_BUTTON',
  },
}
